import { useEffect, useState } from "react"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import './payment-form.css'
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from 'notistack'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useLocation, useNavigate } from "react-router-dom"
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { Switch } from '@mui/material'
import context from '../../scripts/context'



const PaymentForm = ({detail, create, calc}) => {
    dayjs.extend(timezone)
    dayjs.extend(utc)
    const { enqueueSnackbar } = useSnackbar()
    const [validity, setValidity] = useState(dayjs().add(1, 'day'))
    const navigate = useNavigate()
    const {state} = useLocation()
    // const [autoBooking, setAutoBooking] = useState(false)

    const [inputFields, handleChange, setInputFields] = useForm({
        value: {
            name: 'value',
            type: 'text',
            value: '',
            placeholder: '1,000',
            decimal: true
        },
        person: {
            name: 'person',
            type: 'text',
            value: '',
            placeholder: 'محمد احمدی'
        },
        phone: {
            name: 'phone',
            type: 'text',
            value: '',
            placeholder: '912*******'
        },
        email: {
            name: 'email',
            type: 'text',
            value: '',
            placeholder: 'me@example.com'
        },
        pnr: {
            name: 'pnr',
            type: 'text',
            value: '',
            placeholder: 'CNJJUT'
        },
        service: {
            name: 'service',
            type: 'select',
            value: '',
            items:[],
            selected: null,
        },
        paymentGateway:{
            name: 'pgw',
            value: '',
            type: 'select',
            selected: null,
            items: []
        },
        comment: {
            name: 'comment',
            value: '',
            type: 'textarea',
            placeholder: 'Write comment (Optional)'
        }
    })


    const [type, setType] = useState()

    const fillData = () => {
        console.log('to k nmizani')
        setValidity(dayjs(detail.validity))
        // setAutoBooking(detail.autoBooking)
        setInputFields({
            ...inputFields,
            value: {
                ...inputFields.value,
                value: detail.amount.toLocaleString()
            },
            person: {
                ...inputFields.person,
                value: detail.primaryContact
            },
            phone: {
                ...inputFields.phone,
                value: detail.mobile
            },
            email: {
                ...inputFields.email,
                value: (detail.email ? detail.email: '')
            },
            pnr: {
                ...inputFields.pnr,
                value: detail.reference
            },
            service: {
                ...inputFields.service,
                selected: detail.product.id,
                value: detail.product.name
            },
            paymentGateway: {
                ...inputFields.paymentGateway,
                selected: detail.account.id,
                value: detail.account.name
            },
            comment: {
                ...inputFields.comment,
                value: detail.comments
            }
        })
    }

    const handleDatepicker = (e) => {
        setValidity(e)
    }

    const handleSelectDropDown = (service) => {
        console.log(service, ' console service')
        setInputFields({
            ...inputFields,
            service:{
                ...inputFields.service,
                selected: service.id,
                value: service.name
            }
        })
    }

    const handlePGWDropDown = (pgw) => {
        console.log(pgw, ' console pgw')
        setInputFields({
            ...inputFields,
            paymentGateway:{
                ...inputFields.paymentGateway,
                selected: pgw.id,
                value: pgw.name
            }
        })
    }

    const getProductsAndAccounts = async() => {

        const res = await ajax({
            method: 'GET',
            url: utils.urls.accessibleProduct,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        const serviceItems = res.data.map( service => {
            return {
                label: service.name,
                id: service.id,
                data: service
            }
        })

        const response = await ajax({
            method: 'GET',
            url: utils.urls.visiblePaymentGateway,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!response) return
        const IpgAccounts = response.data.filter((account => account.type === 'IPG'))
        const accounts = IpgAccounts.map(acc => {
            return {
                label: acc.name,
                id: acc.id,
                data: acc
            }
        })
        setInputFields({
            ...inputFields,
            paymentGateway:{
                ...inputFields.paymentGateway,
                selected: accounts[0].id,
                items: accounts,
                value: accounts[0].label
            },
            service: {
                ...inputFields.service,
                items: serviceItems,
                selected: serviceItems[0].id,
                value: serviceItems[0].label
            }
        })

        console.log(serviceItems, 'service itmes')

        // setInputFields({
        //     ...inputFields,
        //     service:{
        //         ...inputFields.service,
        //         items: serviceItems
        //     }
        // })


    }

    const fillDataFromCalculatorForm = async() => {
        console.log(state.data, 'this is state from calculator form', inputFields.service.items , 'test test test')
        const res = await ajax({
            method: 'GET',
            url: utils.urls.accessibleProduct,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        const serviceItems = res.data.map( service => {
            return {
                label: service.name,
                id: service.id,
                data: service
            }
        })

        const response = await ajax({
            method: 'GET',
            url: utils.urls.visiblePaymentGateway,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!response) return
        const IpgAccounts = response.data.filter((account => account.type === 'IPG'))
        const accounts = IpgAccounts.map(acc => {
            return {
                label: acc.name,
                id: acc.id,
                data: acc
            }
        })

        const index = serviceItems.findIndex(el => el.label === 'Baggage')

        const data = state.data
        setInputFields({
            ...inputFields,
            value: {
                ...inputFields.value,
                value: data.payableAmount.value
            },
            person: {
                ...inputFields.person,
                value: data.contact?.value
            },
            phone: {
                ...inputFields.phone,
                value: data.mobile?.value
            },
            email: {
                ...inputFields.email,
                value: data.email?.value
            },
            pnr: {
                ...inputFields.pnr,
                value: data.pnr.value
            },
            paymentGateway:{
                ...inputFields.paymentGateway,
                selected: accounts[0].id,
                items: accounts,
                value: accounts[0].label
            },
            service: {
                ...inputFields.service,
                items: serviceItems,
                selected: serviceItems[index].id,
                value: serviceItems[index].label
            }

        })
    }


    useEffect ( () => {
        console.log(state, 'log params')
        if(state && state.type === 'create' && !state.ref){
            getProductsAndAccounts()
            console.log(context.getUserInfo().office.currency.code)
        }
        if(state && state.ref && state.ref === 'calculator' && state.data){
            fillDataFromCalculatorForm()
        }
        if(detail){
            fillData()
            setType('edit')
            return
        }
        console.log(detail, create, 'props')

    }, [detail, create])


    const createTransactionValidation = (data)=>{
        const mobileRegex = /^9\d{9}$/
        // const emailRegex = 
        let m
        let hasError = false
        if ((m = mobileRegex.exec(data.mobile)) == null) {
            enqueueSnackbar('Mobile is not correct', {variant:"error"})
            hasError = true
        }
        if(!data.reference || (data.reference && data.reference.trim().length===0)){
            enqueueSnackbar('Reference is not correct', {variant:"error"})
            hasError = true
        }
        data.reference = data.reference.toUpperCase()
        return hasError
    
    }
    const createTransaction = async() => {

        // console.log(inputFields.service, 'services')
        // console.log(inputFields.paymentGateway, 'pgws')
        // console.log(validity.tz("Asia/Tehran").toISOString(), 'pgws')
        // console.log(validity.utc(true).toISOString(), 'pgws')


        const data = {
            "accountId": inputFields.paymentGateway.selected,
            "validity": validity.tz("Asia/Tehran").utc(true).toISOString(),
            "productId": inputFields.service.selected,
            "paymentType": "LINK",
            "amount": parseInt(inputFields.value.value.replaceAll(',','')),
            "currencyId": detail && detail.currency ? detail.currency.id: getOffice.office.currency.id,
            "autoAmount": false,
            "autoBooking": false,
            "reference": inputFields.pnr.value,
            "primaryContact": inputFields.person.value,
            "mobile": inputFields.phone.value,
            "email": inputFields.email.value,
            "comments": inputFields.comment.value
        }
        const hasError = createTransactionValidation(data)
        if(hasError) {
            return 
        }

        const res = await ajax({
            method: 'POST',
            hasToken: true,
            url: utils.urls.createTransaction,
            data,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        console.log(res, 'created')
        navigate('/agent/payments/send' , {replace: true, state: res.data})
    }
    const getOffice =context.getUserInfo()


    const updateTransaction = async() => {

        console.log(inputFields, 'inputsssssssssseeeeeeeeeee')
        const data = {
            "accountId": inputFields.paymentGateway.selected,
            "validity": validity.tz("Asia/Tehran").utc(true).toISOString(),
            "reference": inputFields.pnr.value,
            "primaryContact": inputFields.person.value,
            "mobile": inputFields.phone.value,
            "email": inputFields.email.value,
            "comments": inputFields.comment.value
        }
        const hasError = createTransactionValidation(data)
        if(hasError) {
            return 
        }

        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateLink(detail.id),
            hasToken: true,
            snackbar: enqueueSnackbar,
            data
        })

        if(!res) return

        navigate('/agent/payments', {replace: true})
    }

    // const handleAutoBooking = (autoBooking) => {
    //     console.log(autoBooking, 'autoBooking')

    //     if(autoBooking){
    //         setAutoBooking(false)
    //     }
    //     if(!autoBooking){
    //         setAutoBooking(true)
    //     }

    // }
    

    return (
        <>
            <div className="form-container__header"> Complete link information</div>

            <div className="value">
                <label>Amount *</label>
                <div className="value-container">
                    <div className="value-input">
                        <Input inputField={inputFields.value} onChange={handleChange} readOnly={(detail ? true : false)}/>
                    </div>
                    <div className="value-currency">{detail && detail.currency ? detail.currency.code : getOffice.office.currency.code}</div>
                </div>
            </div>

            <div className="form-container__inputs">
                <div className="row">
                    <div className="officeId">
                        <label>Contact person</label>
                        <Input
                        className="extra"
                        inputField={inputFields.person}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="officeCode">
                        <label>Mobile*</label>
                        <Input
                        className="extra"
                        inputField={inputFields.phone}
                        onChange={handleChange}
                        />
                    </div>
                    </div>
                    <div className="row">
                    <div className="officeId">
                        <label>Email*</label>
                        <Input
                        className="extra"
                        inputField={inputFields.email}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="officeCode">
                        <label>Reference*</label>
                        <Input
                        className="extra"
                        inputField={inputFields.pnr}
                        onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="officeId">
                        <label>Product</label>
                        <Input
                        className="extra"
                        inputField={inputFields.service}
                        onChange={handleChange}
                        onClickDropdownItem={handleSelectDropDown}
                        readOnly={(detail ? true : false)}
                        />
                    </div>
                    <div className="datePicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>

                            <DateTimePicker
                            label="Expire date"
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                            }}
                            value={validity}
                            onChange={handleDatepicker}
                            ampm={false}
                            format="YYYY-MM-DD HH:mm"
                            />
                        </LocalizationProvider>
                    </div>

                </div>

                <div className="row">
                    <div className="officeId">
                        <label>Payment Gateway</label>
                        <Input
                        className="extra"
                        inputField={inputFields.paymentGateway}
                        onChange={handleChange}
                        onClickDropdownItem={handlePGWDropDown}
                        />
                    </div>

                    {/* <div className="officeCode" style={{paddingTop: "28px"}}>
                        <label>Auto Booking:</label>
                        <Switch color="primary" checked={autoBooking} onChange={() => handleAutoBooking(autoBooking)}/>
                    </div> */}
                    
            </div>
            
            <div className="row">
            <div className="textarea">
                <label>Comment</label>
                    <Input
                    className="extra"
                    inputField={inputFields.comment}
                    onChange={handleChange}
                    />
                </div>
            </div>
        </div>
            {
                type !== 'edit' &&
                <div className="btn-container">
                    <button onClick={() => {navigate('/agent/payments', {replace: true})}} className="payment-btn-back">Back</button>
                    <button onClick={createTransaction} className="payment-btn">Create</button>
                </div>
            }{
                type == 'edit' &&
                <div className="btn-container">
                    <button onClick={() => {navigate('/agent/payments', {replace: true})}} className="payment-btn-back">Back</button>
                    <button onClick={updateTransaction} className="payment-btn">Save</button>

                </div>
            }
        </>
    )
}

export default PaymentForm